import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import { Link } from "react-router-dom";
import { Loader2, Instagram } from "lucide-react";
import { listContas } from "./services/instagramApi";
import InboxLayout from "./components/inbox/InboxLayout";

// Página /instagram/inbox: inbox de Instagram Direct em modo fullscreen.
// Pega automaticamente a primeira conta com status "ativo" (ou a primeira).
export default function InstagramInbox() {
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    listContas()
      .then((data) => setContas(Array.isArray(data) ? data : []))
      .catch(() => setContas([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    // Mesma factory de socket usada no Chat (Meta): origem + path explícito
    // '/api/socket.io/' pra casar com o nginx; cookie via withCredentials.
    const s = io(window.location.origin, {
      path: "/api/socket.io/",
      withCredentials: true,
    });
    setSocket(s);
    return () => { s.disconnect(); };
  }, []);

  const contaAtiva = contas.find((c) => c.status === "ativo") || contas[0];

  if (loading) {
    return (
      <div className="min-h-screen bg-base flex items-center justify-center sm:ml-16">
        <Loader2 className="w-6 h-6 animate-spin text-ink-4" />
      </div>
    );
  }

  if (!contaAtiva) {
    return (
      <div className="min-h-screen bg-base flex flex-col items-center justify-center text-ink-2 p-6 sm:ml-16">
        <Instagram className="w-12 h-12 text-ink-5 mb-4" />
        <h2 className="text-xl font-semibold mb-2">Nenhuma conta Instagram conectada</h2>
        <p className="text-sm text-ink-3 max-w-md text-center mb-6">
          Para usar o inbox, conecte primeiro uma conta Instagram Business em{" "}
          <strong>Instagram → Oficial (Meta)</strong>.
        </p>
        <Link
          to="/instagram/oficial"
          className="px-4 py-2 bg-brand-600 hover:bg-brand-500 rounded text-white text-sm transition"
        >
          Conectar conta
        </Link>
      </div>
    );
  }

  return (
    <div className="h-screen bg-base flex flex-col sm:ml-16">
      <header className="px-6 py-3 border-b border-white/[0.06] flex items-center gap-3 flex-shrink-0">
        <Instagram className="w-5 h-5 text-brand-400" />
        <h1 className="text-lg font-semibold text-white">Instagram Direct</h1>
        <span className="text-xs text-ink-4 ml-2 truncate">
          {contaAtiva.username
            ? `@${contaAtiva.username}`
            : contaAtiva.nome || `Conta #${contaAtiva.id}`}
        </span>
      </header>
      <div className="flex-1 min-h-0">
        <InboxLayout
          contaId={contaAtiva.id}
          socket={socket}
          wrapperClass="flex h-full bg-base overflow-hidden"
        />
      </div>
    </div>
  );
}
